import { Divider, Layout } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import IndexAccolades from './components/accolades/IndexAccolades';
import IndexSkills from './components/skills/IndexSkills';
import {
  HeaderComponent,
  SectionTabs,
} from "@comps/components";
import IndexAssetTypes from './components/assetTypes/IndexAssetTypes';
import IndexCareerLevel from './components/careerLevels/IndexCareerLevel';
import IndexBloodGroups from './components/bloodGroups/IndexBloodGroups';
import IndexContractTypes from './components/employmentTypes/IndexContractTypes';
import IndexEmployeeTypes from './components/employeeTypes/IndexEmployeeTypes';
import IndexCertifications from './components/certifications/IndexCertifications';
import IndexMaritalStatuses from './components/maritalStatuses/IndexMaritalStatuses';
import IndexQualifications from './components/qualifications/IndexQualifications';
import IndexRelationships from './components/relationships/IndexRelationships';
import IndexReligions from './components/religions/IndexReligions';
import IndexSalutations from './components/salutations/IndexSalutations';
import IndexInstitutes from './components/institutes/IndexInstitutes';
import IndexLanguages from './components/languagess/IndexLanguages';
import IndexOccupationTypes from './components/occupationTypes/IndexOccupationTypes';
import IndexCountries from './components/countries/IndexCountries';
import IndexStates from './components/states/IndexStates';
import IndexCities from './components/cities/IndexCities';
import IndexDocuments from './components/documentss/IndexDocuments';
import IndexDocumentTypes from './components/documentTypes/IndexDocumentTypes';
import IndexWows from './components/wow/IndexWows';
import IndexNewsLetters from './components/newsletter/IndexNewsLetters';
import IndexCurrencies from './components/currency/IndexCurrencies';
import IndexAssets from './components/assetss/IndexAssets';
import IndexBenefits from './components/benefits/IndexBenefits';
import IndexKpi from './kpiManagement/kpi/IndexKpi';
import IndexKpiAllocation from './kpiManagement/kpi/IndexKpiAllocation';
import IndexKpiEvaluation from './kpiManagement/kpi/components/kpiEvaluation.jsx/IndexKpiEvaluation';
import { checkPermissions } from '@comps/commonFunctions';
import IndexTodo from './components/todo/IndexTodo';

const { Content } = Layout;
const GENERAL_MASTER_TAB_KEY = "generalMasterActiveTab";
const GENERAL_MASTER_KPI_TAB_KEY = "generalMasterKpiActiveTab";
const KPI_TAB_KEYS = ["kpi", "kpiAllocation", "kpiEvaluation"];
const GENERAL_TAB_LABELS = {
  todo: "To Do",
  kpi: "KPIs",
  kpiAllocation: "KPI Allocations",
  kpiEvaluation: "KPI Evaluations",
  accolades: "Accolades",
  skills: "Skills",
  careerLevels: "Career Levels",
  assets: "Assets",
  assetTypes: "Asset Types",
  benefits: "Benefits",
  bloodGroups: "Blood Groups",
  certifications: "Certifications",
  cities: "Cities",
  countries: "Countries",
  currencies: "Currencies",
  documents: "Documents",
  documentTypes: "Document Types",
  employeeTypes: "Employee Types",
  contractTypes: "Employment Types",
  institutes: "Institutes",
  languages: "Languages",
  occupationTypes: "Occupation Types",
  maritalStatuses: "Marital Statuses",
  newsLetters: "News Letters",
  relationships: "Relationships",
  religions: "Religions",
  qualifications: "Qualifications",
  states: "States",
  salutations: "Salutations",
  wordsOfWisdoms: "Words of Wisdoms",
};

const IndexGeneralMasters = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  //------------use states start----------------
  const [currentTab, setCurrentTab] = useState(() => localStorage.getItem(GENERAL_MASTER_TAB_KEY) || 'KpiManagement');
  const [currentKpiTab, setCurrentKpiTab] = useState(() => localStorage.getItem(GENERAL_MASTER_KPI_TAB_KEY) || 'kpi');
  //-----------end use states--------------------
  const onChangeTab = (e) => {
    localStorage.setItem(GENERAL_MASTER_TAB_KEY, e);
    setSearchParams({ tab: e });
    setCurrentTab(e)
  };
  const onChangeKpiTab = useCallback((e) => {
    localStorage.setItem(GENERAL_MASTER_TAB_KEY, 'KpiManagement');
    localStorage.setItem(GENERAL_MASTER_KPI_TAB_KEY, e);
    setSearchParams({ tab: e });
    setCurrentTab('KpiManagement');
    setCurrentKpiTab(e);
  }, [setSearchParams]);
  const allowedTabKeys = useMemo(() => [
    checkPermissions('todo') ? 'todo' : null,
    KPI_TAB_KEYS.some((key) => checkPermissions(key)) ? 'KpiManagement' : null,
    ...Object.keys(GENERAL_TAB_LABELS).filter((key) => !KPI_TAB_KEYS.includes(key) && key !== 'todo' && checkPermissions(key)),
  ].filter(Boolean), []);
  const kpiSections = useMemo(() => [
    { key: 'kpi', label: "KPIs", modkey: 'kpi', children: <IndexKpi modkey="kpi" /> },
    { key: 'kpiAllocation', label: "Allocations", modkey: 'kpiAllocation', children: <IndexKpiAllocation modkey="kpiAllocation" /> },
    { key: 'kpiEvaluation', label: "Evaluations", modkey: 'kpiEvaluation', children: <IndexKpiEvaluation modkey="kpiEvaluation" /> },
  ], []);

  // One ordered list instead of ~30 hand-written panes: SectionTabs drops the
  // ones the role cannot see and keeps the rest reachable without a hidden menu.
  const sections = useMemo(() => [
    // { key: 'todo', modkey: 'todo', children: <IndexTodo modkey="todo" /> },
    // {
    //   key: 'KpiManagement',
    //   label: "KPI Management",
    //   children: (
    //     <SectionTabs
    //       className="general-masters__kpi-tabs"
    //       activeKey={ currentKpiTab }
    //       onChange={ onChangeKpiTab }
    //       items={ kpiSections }
    //     />
    //   ),
    // },
    { key: 'accolades', modkey: 'accolades', children: <IndexAccolades modkey="accolades" /> },
    { key: 'skills', modkey: 'skills', children: <IndexSkills modkey="skills" /> },
    { key: 'careerLevels', modkey: 'careerLevels', children: <IndexCareerLevel modkey="careerLevels" /> },
    { key: 'assets', modkey: 'assets', children: <IndexAssets modkey="assets" /> },
    { key: 'assetTypes', modkey: 'assetTypes', children: <IndexAssetTypes modkey="assetTypes" /> },
    { key: 'benefits', modkey: 'benefits', children: <IndexBenefits modkey="benefits" /> },
    { key: 'bloodGroups', modkey: 'bloodGroups', children: <IndexBloodGroups modkey="bloodGroups" /> },
    { key: 'certifications', modkey: 'certifications', children: <IndexCertifications modkey="certifications" /> },
    { key: 'cities', modkey: 'cities', children: <IndexCities modkey="cities" /> },
    { key: 'countries', modkey: 'countries', children: <IndexCountries modkey="countries" /> },
    { key: 'currencies', modkey: 'currencies', children: <IndexCurrencies modkey="currencies" /> },
    { key: 'documents', modkey: 'documents', children: <IndexDocuments modkey="documents" /> },
    { key: 'documentTypes', modkey: 'documentTypes', children: <IndexDocumentTypes modkey="documentTypes" /> },
    { key: 'employeeTypes', modkey: 'employeeTypes', children: <IndexEmployeeTypes modkey="employeeTypes" /> },
    { key: 'contractTypes', modkey: 'contractTypes', children: <IndexContractTypes modkey="contractTypes" /> },
    { key: 'institutes', modkey: 'institutes', children: <IndexInstitutes modkey="institutes" /> },
    { key: 'languages', modkey: 'languages', children: <IndexLanguages modkey="languages" /> },
    { key: 'occupationTypes', modkey: 'occupationTypes', children: <IndexOccupationTypes modkey="occupationTypes" /> },
    { key: 'maritalStatuses', modkey: 'maritalStatuses', children: <IndexMaritalStatuses modkey="maritalStatuses" /> },
    { key: 'newsLetters', modkey: 'newsLetters', children: <IndexNewsLetters modkey="newsLetters" /> },
    { key: 'relationships', modkey: 'relationships', children: <IndexRelationships modkey="relationships" /> },
    { key: 'religions', modkey: 'religions', children: <IndexReligions modkey="religions" /> },
    { key: 'qualifications', modkey: 'qualifications', children: <IndexQualifications modkey="qualifications" /> },
    { key: 'states', modkey: 'states', children: <IndexStates modkey="states" /> },
    { key: 'salutations', modkey: 'salutations', children: <IndexSalutations modkey="salutations" /> },
    { key: 'wordsOfWisdoms', modkey: 'wordsOfWisdoms', children: <IndexWows modkey="wordsOfWisdoms" /> },
  ].filter((section) => section.key !== 'KpiManagement' || KPI_TAB_KEYS.some((key) => checkPermissions(key)))
    .map((section) => ({ ...section, label: section.label || GENERAL_TAB_LABELS[section.key] })),
    [currentKpiTab, kpiSections, onChangeKpiTab]);

  useEffect(() => {
    const requestedTab = searchParams.get('tab');
    if (!requestedTab) return;

    if (KPI_TAB_KEYS.includes(requestedTab) && checkPermissions(requestedTab)) {
      localStorage.setItem(GENERAL_MASTER_TAB_KEY, 'KpiManagement');
      localStorage.setItem(GENERAL_MASTER_KPI_TAB_KEY, requestedTab);
      setCurrentTab('KpiManagement');
      setCurrentKpiTab(requestedTab);
      return;
    }

    if (allowedTabKeys.includes(requestedTab)) {
      localStorage.setItem(GENERAL_MASTER_TAB_KEY, requestedTab);
      setCurrentTab(requestedTab);
    }
  }, [allowedTabKeys, searchParams]);
  //-----------styling------------

  const TabContentStyle = { background: 'white', padding: '10px 20px 20px' }
  // No title/breadcrumb: the workspace nav and the tab bar below already say
  // where you are, so a header here was redundant and only ate vertical space.
  const pageConfig = {
    headers: {
      title: "",
    },
  };
  //----------end styling-----------

  return (
    <>
      <Layout>

        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>

        </HeaderComponent>

        <Layout hasSider>
          <Content style={ TabContentStyle }>
            <SectionTabs
              activeKey={ currentTab }
              onChange={ onChangeTab }
              items={ sections }
            />
          </Content>
          <Divider orientation='left' type='vertical' />

        </Layout>

      </Layout>


    </>
  );


};
export default IndexGeneralMasters;
